import React from "react";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckSquare,
  faSquare,
  faChevronRight,
  faChevronDown,
  faMinusSquare,
} from "@fortawesome/free-solid-svg-icons";
import "./CheckboxTree.scss";

const icons = {
  check: (
    <FontAwesomeIcon className="rct-icon rct-icon-check" icon={faCheckSquare} />
  ),
  uncheck: (
    <FontAwesomeIcon className="rct-icon rct-icon-uncheck" icon={faSquare} />
  ),
  halfCheck: (
    <FontAwesomeIcon
      className="rct-icon rct-icon-half-check"
      icon={faMinusSquare}
    />
  ),
  expandClose: (
    <FontAwesomeIcon
      className="rct-icon rct-icon-expand-close"
      icon={faChevronRight}
    />
  ),
  expandOpen: (
    <FontAwesomeIcon
      className="rct-icon rct-icon-expand-open"
      icon={faChevronDown}
    />
  ),
  expandAll: "expand all",
  collapseAll: "collapse",
  parentClose: null,
  parentOpen: null,
  leaf: null,
};

export default function AS_CheckboxTree(props) {
  return <CheckboxTree showNodeIcon={false} icons={icons} {...props} />;
}
